import { useSelector } from "react-redux"
import { RootState } from "../app/store"

const useAuth =()=>{

const {user}= useSelector((state :RootState)=>state.auth)
const {superAdminUser}= useSelector((state :RootState)=>state.superAdminAuth)

const isLoggedIn = user ? true :false
const isSuperAdminLoggedIn = superAdminUser ? true :false

return {isLoggedIn,user,isSuperAdminLoggedIn,superAdminUser}

};

export default useAuth;